import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FollowersByDateStatistics from './FollowersByDateStatistics';
import FollowersByDateSidebar from './FollowersByDateSidebar';
import StatisticsPageViewGraph from './StatisticsPageViewGraph';
import StatisticsSideBar from './StatisticsSideBar';
import FollowStatistics from './FollowStatistics';
import KeyStatistics from './KeyStatistics';

export default class ProfileStatisticsUI extends PureComponent {
    static propTypes = {
        lastNDays: PropTypes.number,
        lastNFollowers: PropTypes.array,
        profileStatistics: PropTypes.object,
    };

    render() {
        return (
            <React.Fragment>
                <KeyStatistics
                    lastNDays={this.props.lastNDays}
                    lastNFollowers={this.props.lastNFollowers}
                    lastNVisists={
                        this.props.profileStatistics.totalUniqueVisits
                    }
                    totalFollowers={
                        this.props.profileStatistics.numberOfFollowers
                    }
                />

                <div className="grid t-grid">
                    <div className="grid__unit u-r-size2of3">
                        <div className="panel">
                            <h3>Besøkende per dag</h3>
                            <StatisticsPageViewGraph
                                profileStatistics={this.props.profileStatistics}
                            />
                        </div>
                    </div>
                    <div className="grid__unit u-r-size1of3">
                        <StatisticsSideBar
                            totalCount={
                                this.props.profileStatistics.totalUniqueVisits
                            }
                        />
                    </div>
                </div>
                <div className="grid t-grid">
                    <div className="grid__unit u-r-size2of3">
                        <FollowersByDateStatistics
                            lastNFollowers={this.props.lastNFollowers}
                        />
                    </div>
                    <div className="grid__unit u-r-size1of3">
                        <FollowersByDateSidebar
                            lastNDays={this.props.lastNDays}
                            lastNFollowers={this.props.lastNFollowers}
                            noFollowers={
                                this.props.profileStatistics.numberOfFollowers
                            }
                        />
                    </div>
                </div>
                <FollowStatistics
                    ages={this.props.profileStatistics.age}
                    numberOfProfiles={
                        this.props.profileStatistics.numberOfProfiles
                    }
                    sexStats={this.props.profileStatistics.sex}
                    skills={this.props.profileStatistics.tags}
                />
            </React.Fragment>
        );
    }
}
